'use strict';

angular
    .module('webmailWrapper')
    .service('errorMapper', function(translationProvider) {
        var map = {
            81004: translationProvider.instant('TR_070525-76e063_TR')
        };

        this.has = function(code) {
            return code in map;
        };

        this.map = function(error) {
            if (!(error.code in map)) {
                return;
            }
            var msg = map[error.code];
            if (msg.includes('{}')) {
                msg = msg.replace('{}', error.context);
            }
            return msg;
        };
    });
